const SESSION_SAUCE_EMPLOYEE_NAME = 'IsSauceEmployee';

export default SESSION_SAUCE_EMPLOYEE_NAME;
